import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Form} from 'formik';
import Button from '../../components/Button';
import styles from './styles.module.scss';

const Step7View = () => {
  return (
    <Form className={styles.formContainer}>
      <div className={styles.contentBlock}>
        <div className={styles.titleBold}>
          <FormattedMessage
            id={'step7.form.title'}
          />
        </div>
        <div className={`${styles.textBold} ${styles.subheader}`}>
          <FormattedMessage
            id={'step7.v1.nationalInsurance.explanation.title'}
            defaultMessage={'The explanation should be read carefully'}
          />
        </div>
        <div className={styles.textMedium}>
          <FormattedMessage
            id={'step7.v1.nationalInsurance.text.1.p1'}
            defaultMessage={'Please note that your status in the National Insurance is that of self-employed and not of an employee according to an instruction of the National Insurance Institute. You are only an employee for income tax purposes.'}
          />
        </div>
        <div className={styles.textMedium}>
          <FormattedMessage
            id={'step7.v1.nationalInsurance.text.1.p2'}
            defaultMessage={'In order to facilitate the reporting and payment to the National Insurance, we can handle this for you as part of our service and at no additional cost.'}
          />
        </div>
        <div className={styles.textMedium}>
          <FormattedMessage
            id={'step7.v1.nationalInsurance.text.1.p3'}
            defaultMessage={'All you have to do is send us an email to the address: office@atzmai.co.il and state that you want us to issue a National Insurance power of attorney form for you.'}
            values={{
              mailto: str => (
                <a href='mailto:office@atzmai.co.il' className={styles.textLink}>
                  {str}
                </a>
              )
            }}
          />
        </div>
      </div>
      <div className={styles.contentBlock}>
        <div className={styles.textBold}>
          <FormattedMessage
            id={'step7.v1.nationalInsurance.text.2'}
            defaultMessage={'What does it actually mean to be self-employed in the National Insurance?'}
          />
        </div>
        <div className={styles.list}>
          <span className={styles.textMedium}>
            <FormattedMessage
              id={'step7.v1.option1.text.1'}
              defaultMessage={'If your income is less than 3000 NIS per month and you work less than 12 hours per week, you will be considered self-employed who do not meet the definition and will only pay the minimum for National Insurance (approximately 194 NIS).'}
            />
          </span>
        </div>
        <div className={styles.list}>
          <span className={styles.textMedium}>
            <FormattedMessage
              id={'step7.v1.option1.text.2'}
              defaultMessage={'In this definition - you will not be entitled to social security pensions and you will not be insured in the industry for work injuries.'}
            />
          </span>
        </div>
        <div className={styles.list}>
          <span className={styles.textMedium}>
            <FormattedMessage
              id={'step7.v1.option1.text.3'}
              defaultMessage={'If you work another job - you will not have to pay the minimum.'}
            />
          </span>
        </div>
        <div className={styles.list}>
          <span className={styles.textMedium}>
            <FormattedMessage
              id={'step7.v1.option2.text.1'}
              defaultMessage={'If your income is higher than NIS 3000 and you work more than 12 hours a week, you will be considered self-employed who meet the definition and will pay advances according to the income you declare.'}
            />
          </span>
        </div>
        <div className={styles.list}>
          <span className={styles.textMedium}>
            <FormattedMessage
              id={'step7.v1.option2.text.2'}
              defaultMessage={'In this definition - you will be entitled to social insurance pensions as self-employed and you will be insured in the industry for work injuries.'}
            />
          </span>
        </div>
        <div className={styles.list}>
          <span className={styles.textMedium}>
            <FormattedMessage
              id={'step7.v1.option2.text.3'}
              defaultMessage={'If you work at another job - you will have to pay in both places.'}
            />
          </span>
        </div>
        <div className={styles.list}>
          <span className={styles.textMedium}>
            <FormattedMessage
              id={'step7.v1.note'}
              defaultMessage={'* The case can be closed at any moment by notifying us.'}
            />
          </span>
        </div>
      </div>
      <div className={styles.innerPadding}>
        <Button
          type='submit'
          label={(
            <FormattedMessage
              id='common.form.button.save'
              defaultMessage='Save'
            />
          )}
        />
      </div>
    </Form>
  )
};

Step7View.propTypes = {
  translationKeys: PropTypes.shape({
    option1Title: PropTypes.string.isRequired,
    option1Text1: PropTypes.string.isRequired,
    option1Text2: PropTypes.string.isRequired,
    option1Text3: PropTypes.string.isRequired,
  })
};

export default Step7View;
